import React from 'react';
import { Button } from '../../../../components';
import css from './AwardCard.css';
import { IconClockS } from '../../../../icons';
import classNames from 'classnames';

const Header = ({ children }) => <h3>{children}</h3>;

const Description = ({ children }) => <p className={css.description}>{children}</p>;

const Badge = ({ children }) => <div className={css.badge}>{children}</div>;

const Action = ({
    onClick = () => null,
    actionText,
    actionSubLabel,
    disabled = false,
    renderButton,
}) => (
    <>
        <p className={css.sidenote}>
            <IconClockS /> <span>{actionSubLabel || 'Sofortige Gutschrift'}</span>
        </p>
        {typeof renderButton === 'function' ? (
            renderButton()
        ) : (
            <Button onClick={onClick} disabled={disabled}>
                {actionText || 'Reward erhalten'}
            </Button>
        )}
    </>
);

export const AwardCard = ({ children, rootClassName }) => {
    return (
        <div className={classNames(css.root, { [rootClassName]: !!rootClassName })}>{children}</div>
    );
};

AwardCard.Header = Header;
AwardCard.Description = Description;
AwardCard.Badge = Badge;
AwardCard.Action = Action;
